
export default 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ';
//# sourceMappingURL=gif.invalid.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/media/gif.invalid.js
// module id = 208
// module chunks = 0 1